// Exclusivamente apresentação: nunca usar este predicado para dispensar
// consultas, validação de quantidade ou elegibilidade do pedido.
export function ocultarEstoqueCertificacao(tipoPedidoId) {
  return String(tipoPedidoId || '').trim().toUpperCase() === 'WC';
}

// O tipo explicitamente selecionado prevalece sobre capas antigas em cache.
// Em um catálogo combinado (WS,WC), não inferir WC da flag assessment do SKU.
export function tipoPedidoSelecionadoParaEstoque(store) {
  const form = store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
  return form.tipoPedidoCliente?.tipopedidoid
    || form.tipoPedido?.tipopedidoid
    || store.getters['intensPedido/getFormData']?.dataCapaPedido?.tipopedidoid
    || null;
}